import { fetchShopPackages } from './api'

export default {
  state: () => ({
    list: [],
    packageDict: {},
    checkList: [],
    moneyUnit: '',
    isLoading: true,
    listId: '',
    activityData: { activity_notice: '', cutdown_time: 0 },
    activityBanner: '',
    gatewayPackageIds: {},
    supportGateways: [],
    advanceCardSupport: false,
    adyenDecimalPrecision: 2,
    showBonus: false,
    paypalClientId: '',
  }),

  mutations: {
    SET_LIST(state, list) {
      state.list = list
    },
    SET_PACKAGE_DICT(state, dict) {
      state.packageDict = dict
    },
    SET_CHECK_LIST(state, list) {
      state.checkList = list
    },
    SET_MONEY_UNIT(state, unit) {
      state.moneyUnit = unit
    },
    SET_LOADING(state, v) {
      state.isLoading = v
    },
    SET_LIST_ID(state, id) {
      state.listId = id
    },
    SET_ACTIVITY_DATA(state, data) {
      state.activityData = data
    },
    SET_ACTIVITY_BANNER(state, url) {
      state.activityBanner = url
    },
    SET_GATEWAY_PACKAGE_IDS(state, ids) {
      state.gatewayPackageIds = ids
    },
    SET_SUPPORT_GATEWAYS(state, gateways) {
      state.supportGateways = gateways
    },
    SET_ADVANCE_CARD_SUPPORT(state, v) {
      state.advanceCardSupport = v
    },
    SET_ADYEN_DECIMAL_PRECISION(state, v) {
      state.adyenDecimalPrecision = v
    },
    SET_SHOW_BONUS(state, v) {
      state.showBonus = v
    },
    SET_PAYPAL_CLIENT_ID(state, id) {
      state.paypalClientId = id
    },
  },

  actions: {
    async init({ commit }, context) {
      commit('SET_LOADING', true)
      try {
        const requestParams = {
          game_id: context.gameId,
          currency: context.currency,
          language_code: context.locale,
          os: context.isMobile ? 'mobile' : 'pc',
          display_all: 1,
        }
        if (context.listId) {
          requestParams.list_id = context.listId
        }

        const res = await fetchShopPackages(requestParams)

        if (res.data.code == 1) {
          const data = res.data.data
          const config = data.config
          const list = config.list.map((item) => ({ ...item, list_id: data.id }))

          commit('SET_LIST', list)
          commit('SET_LIST_ID', data.id)
          commit('SET_CHECK_LIST', config.checkList || [])
          commit('SET_ACTIVITY_BANNER', data.banner_icon || '')
          commit('SET_GATEWAY_PACKAGE_IDS', data.gateway_package_ids || {})
          commit('SET_SUPPORT_GATEWAYS', data.support_gateways || [])
          commit('SET_ADVANCE_CARD_SUPPORT', data.is_advance_card_support_currency || false)
          commit('SET_ADYEN_DECIMAL_PRECISION', data.decimal_precision)
          commit('SET_SHOW_BONUS', data.show_bonus === 1)
          commit('SET_PAYPAL_CLIENT_ID', data.paypal_client_id || '')

          // 构建字典
          const dict = {}
          list.forEach((item) => {
            dict['package' + item.id] = item
          })
          commit('SET_PACKAGE_DICT', dict)

          // 货币单位
          if (list.length > 0) {
            commit('SET_MONEY_UNIT', list[0].package.currency_label + ' ')
          }

          // 活动倒计时
          if (data.activity_notice && data.activity_end_time > data.now_time) {
            commit('SET_ACTIVITY_DATA', {
              activity_notice: data.activity_notice,
              cutdown_time: data.activity_end_time - data.now_time,
            })
          }
        }
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },

  getters: {
    hasPackages: (state) => state.list.length > 0,
    getPackageById: (state) => (id) => state.packageDict['package' + id] || null,
  },
}
